module.exports = __webpack_public_path__ + "img/office.6a0db50d.jpeg";